import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import {
  getTPASettignsLiveSiteEditingDeprecated,
  type NormalizedCategory,
} from '@wix/communities-blog-client-common';
import usePermissions from '@app/external/common/hooks/use-permissions';
import EmptyStates from '../../../common/components/empty-states';
import { useSelector } from '../../../common/components/runtime-context';
import CreatePostButton from '../create-post-button';

type Props = {
  category: NormalizedCategory | undefined;
};

const NoPostsWithWriterCTA: React.FC<Props> = ({ category }) => {
  const { t } = useTranslation();
  const isLiveSiteEditingDisabled = useSelector(getTPASettignsLiveSiteEditingDeprecated);
  const { can } = usePermissions();
  const isWriter = can('create', 'post');

  return isWriter && !isLiveSiteEditingDisabled ? (
    <EmptyStates
      title={t('no-posts-writer.create-posts')}
      content={t('no-posts-writer.readers-would-love')}
      controls={<CreatePostButton categorySlug={category?.slug} />}
    />
  ) : (
    <EmptyStates
      title={t('no-posts.posts-coming-soon')}
      content={t('no-posts.explore-other-categories')}
    />
  );
};

export default NoPostsWithWriterCTA;
